var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock-fill",
    clipPath: "url(#clip0_3035_8077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 2C12.7956 2 13.5587 2.31607 14.1213 2.87868C14.6839 3.44129 15 4.20435 15 5V11H9V5C9 4.20435 9.31607 3.44129 9.87868 2.87868C10.4413 2.31607 11.2044 2 12 2ZM16.5 11V5C16.5 3.80653 16.0259 2.66193 15.182 1.81802C14.3381 0.974106 13.1935 0.5 12 0.5C10.8065 0.5 9.66193 0.974106 8.81802 1.81802C7.97411 2.66193 7.5 3.80653 7.5 5V11C6.70435 11 5.94129 11.3161 5.37868 11.8787C4.81607 12.4413 4.5 13.2044 4.5 14V21.5C4.5 22.2956 4.81607 23.0587 5.37868 23.6213C5.94129 24.1839 6.70435 24.5 7.5 24.5H16.5C17.2956 24.5 18.0587 24.1839 18.6213 23.6213C19.1839 23.0587 19.5 22.2956 19.5 21.5V14C19.5 13.2044 19.1839 12.4413 18.6213 11.8787C18.0587 11.3161 17.2956 11 16.5 11Z",
    fill: "#1C2026"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3035_8077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFilled);
export default __webpack_public_path__ + "static/media/lock-filled.d2d6112c52049795a44d48d496f2a013.svg";
export { ForwardRef as ReactComponent };